<template>
	<div class="ability-detail" @click="; (videoFlag = false), (audioFlag = false)">
		<div class="ability-detail-header" @click="routeBack('')">
			<i class="el-icon-arrow-left" style="margin-right: 5px;font-weight: 1000;"></i>返回
		</div>

		<el-form :model="ruleForm" ref="ruleForm" label-width="80px" class="ability-detail-form"
			:hide-required-asterisk="true" :rules="rules">
			<div class="form-item-title">选择题型</div>
			<el-form-item label="题目类型" prop="type">
				<InputTopTip v-model="ruleForm.type" placeholder="题目类型" :marginTop="14">
					<el-select @change="subjectTypeChangeEvent" v-model="ruleForm.type" placeholder="" class="width-453">
						<el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					</el-select>
				</InputTopTip>
			</el-form-item>

			<div class="form-item-title">题目内容</div>
			<el-form-item label="题干" prop="body">
				<quillTextLight v-if="gapFormFlag" class="quill-text" :content="body"
					@changeContent="updateContent('body', $event)" :placeholder="placeholder" @insertText="onInsertText" />
				<quillText v-else class="quill-text" :content="ruleForm.body" @changeContent="updateContent('body', $event)"
					:placeholder="placeholder" />
				<el-checkbox v-model="ruleForm.extras[0]" v-if="ruleForm.type == 3">允许学生答案与参考答案顺序不一致，且互斥</el-checkbox>
			</el-form-item>
			<!-- 单选 ~ answer字符串 -->
			<el-form-item label="题肢" prop="answer" v-if="radioFormFlag">
				<div class="form-item-inscription">
					<div class="form-item-inscription-tip">*请点击字母前的圆圈选择本题正确答案</div>
					<div class="flex-align-baseline" v-for="(item, index) in list" :key="item.id">
						<el-radio v-model="ruleForm.answer" :label="index">{{ numToColNo(index) }}</el-radio>
						<quillText :placeholder="`选项例子${numToColNo(index)}`" class="quill-text" :content="item.content"
							@changeContent="onInput(index, $event)" />
						<div class="icon-circle" @click="inscriptionDeleteClick(item.id)">
							<i class="el-icon-delete" style="color: #ff1f1f;"></i>
						</div>
					</div>
					<el-button class="form-item-inscription-button" @click="inscriptionNewCreateClick">
						<i class="el-icon-plus" style="margin-right: 7px;"></i>新增更多
					</el-button>
				</div>
			</el-form-item>
			<!-- 多选 ~ answer数组 -->
			<el-form-item label="题肢" prop="answer" v-if="moreRadioFormFlag">
				<div class="form-item-inscription">
					<div class="form-item-inscription-tip">*请点击字母前的圆圈选择本题正确答案</div>
					<el-checkbox-group v-model="ruleForm.answer">
						<div class="flex-align-baseline" v-for="(item, index) in list" :key="item.id">
							<el-checkbox :label="index">{{ numToColNo(index) }}</el-checkbox>
							<quillText :placeholder="`选项例子${numToColNo(index)}`" class="quill-text" :content="item.content"
								@changeContent="onInput(index, $event)" />
							<div class="icon-circle" @click="inscriptionDeleteClick(item.id, numToColNo(index))">
								<i class="el-icon-delete" style="color: #ff1f1f;"></i>
							</div>
						</div>
						<el-button class="form-item-inscription-button" @click="inscriptionNewCreateClick">
							<i class="el-icon-plus" style="margin-right: 7px;"></i>新增更多
						</el-button>
					</el-checkbox-group>
				</div>
			</el-form-item>
			<!-- 连线题 ~ answer二维数组 -->
			<el-form-item label="题肢" prop="answer" v-show="connectFormFlag">
				<connectLine :groupNumber="ruleForm.extras[1]?.groupNum" :items="items" :connections="connections"
					@change-items="changeItems" @change-all="changeAll" @change-connections="changeConnections"
					class="connect-line" />
			</el-form-item>

			<!-- 题肢随机 -->
			<el-form-item label="题肢随机" prop="answer" v-if="([1, 2, 11].includes(ruleForm.type))">
				<el-switch v-model="ruleForm.extras[0]" :width="32"></el-switch>
			</el-form-item>

			<!-- 排序题 ~ answer -->
			<el-form-item label="排列条目" prop="answer" v-if="ruleForm.type == 10">
				<div class="form-item-inscription" _p="!x-10px">
					<div class="form-item-inscription-tip" _bg="[#FFF6F6]" _m="b-10px" _text="![#FD5E5E]">
						<i class="el-icon-warning-outline" _m="x-5px"></i>请按标准答案排序
					</div>
					<div _flex="~" v-for="(item, index) in list" :key="item.id">
						<!-- <el-radio v-model="ruleForm.answer" :label="index">{{ index + 1 }}</el-radio> -->
						<div _w="45px" _h="45px" _m="r-10px" _flex="~ items-center justify-center">
							<span _w="40px" _text="16px [#535353]" _h="40px" _bg="[#F5F5F5]"
								_border="solid [#dcdcdc] 1px rounded-[5px]" _flex="~ items-center justify-center">{{ index + 1 }}</span>
						</div>
						<quillText :placeholder="``" class="quill-text" :content="item.content"
							@changeContent="onInput(index, $event)" />
						<div _flex="~">
							<div _flex="~ col">
								<el-button _h="!20px" _flex="!~ !items-center" size="mini" :style="{ opacity: index != 0 ? 1 : .3 }"
									@click="changePositionClick('up', index)" icon="el-icon-arrow-up"></el-button>
								<el-button _h="!20px" _flex="!~ !items-center" _m="!t-5px" size="mini"
									:style="{ opacity: list.length - 1 != index ? 1 : .3, marginLeft: '0 !important' }"
									@click="changePositionClick('down', index)" icon="el-icon-arrow-down"></el-button>
							</div>
							<div _m="l-5px" _w="45px" _border="rounded-[5px]" _h="45px" _bg="[#FFF1F1]"
								_flex="~ justify-center items-center" @click="inscriptionDeleteClick(item.id)">
								<i class="el-icon-delete" style="color: #ff1f1f;"></i>
							</div>
						</div>
					</div>
					<el-button class="form-item-inscription-button" @click="inscriptionNewCreateClick">
						<i class="el-icon-plus" style="margin-right: 7px;"></i>新增更多
					</el-button>
				</div>
			</el-form-item>

			<!-- 美术特色选择题 -->
			<el-form-item label="题肢" prop="answer" v-if="artisticFeaturesVisible">
				<art />
			</el-form-item>

			<!-- 美术特色选择题 -->
			<el-form-item label="题肢" prop="answer" v-if="musicalFeatureVisible">
				<music />
			</el-form-item>

			<el-form-item v-if="ruleForm.type === 15" label="创编类型" prop="create_type">
				<el-select v-model="ruleForm.create_type" placeholder="请选择创编类型">
					<el-option v-for="item in [
						{ label: '旋律' },
						{ label: '节奏' },
						{ label: '歌词' },
						{ label: '旋律+节奏' },
						{ label: '旋律+歌词' },
						{ label: '歌词+节奏' },
						{ label: '旋律+歌词+节奏' }
					]" :key="item.label" :label="item.label" :value="item.label">
					</el-option>
				</el-select>
			</el-form-item>
			<!-- 演唱题 -->
			<el-form-item label="谱例" prop="musical_id" v-if="singFormFlag">
				<div v-if="!ruleForm.musical_id">
					<template v-if="ruleForm.type === 9">
						<el-button type="primary" @click="singGenealogyVisible = true">从谱音同步选择谱例</el-button>
					</template>
					<template v-if="ruleForm.type !== 9">
						<el-button type="primary" @click="genealogyVisible = true">从谱例库选择谱例</el-button>
					</template>
					<!-- <el-button type="primary" @click="singGenealogyVisible = true">从谱音同步选择谱例</el-button>
          <el-button type="primary" @click="genealogyVisible = true">从谱例库选择谱例</el-button> -->
					<div _text="[#000000]" _opacity="[0.5]" v-if="![4, 5, 18, 24].includes(ruleForm.type)">
						请选择谱音同步的谱例
					</div>
				</div>

				<div _flex="~ col justify-center items-center" _w="90px" v-else>
					<div _border="rounded-5px 1px solid [#cfd7e7]" _pos="relative" _w="90px" _h="90px">
						<i class="el-icon-error" _pos="absolute" _right="-8px" _top="-8px" _cursor="pointer" _z="1"
							_text="18px [#cfd7e7]" @click="ruleForm.musical_id = '', $set(ruleForm, 'extras', [])"></i>
						<img :src="require('@/assets/test_client/Group.png')" _m="l-5px t-8px" />
					</div>
					<div _m="t-9px" style="line-height: 1;text-overflow: ellipsis;white-space: nowrap;width: 100%">{{
						ruleForm.extras[0]
					}}</div>
				</div>
			</el-form-item>

			<el-form-item label="谱面呈现方式" v-if="singFormFlag && [4].includes(ruleForm.type)" _m="!y-40px">
				<InputTopTip v-model="ruleForm.extras[1]" placeholder="请选择呈现方式" :marginTop="13">
					<el-select v-model="ruleForm.extras[1]" placeholder="" class="width-453">
						<el-option v-for="item in spectralPlaneMap" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</InputTopTip>
			</el-form-item>

			<el-form-item label="音准偏移" prop="musical_offset" v-if="singFormFlag && ![4, 18, 24].includes(ruleForm.type)">
				<!-- <el-input v-model="ruleForm.musical_offset" type="number" class="width-453" placeholder="请输入音准偏移量"></el-input> -->
				<el-input-number class="num-input" v-model="ruleForm.musical_offset" :min="0" :max="999999"
					label="请输入音准偏移量"></el-input-number>
			</el-form-item>

			<el-form-item label="音准线" v-if="singFormFlag && [9].includes(ruleForm.type)">
				<el-switch v-model="ruleForm.extras[1]" active-color="#ff5e2a"></el-switch>
				<span _text="[#000000]" _opacity="[0.5]" _m="l-20px">
					*说明：打开开关则表示授课端显示音准线，音准线可以判定学生的演唱音高，关闭则不显示。
				</span>
			</el-form-item>

			<el-form-item label="音符选项" v-if="singFormFlag && ruleForm.type == 18 && ruleForm.extras[0]">
				<el-button type="primary" @click="genealogySee" class="action-btn" style="width: 120px; margin-right: 15px;"
					:disabled="ruleForm.musical_id == ''">识别谱例</el-button>
				<span v-if="ruleForm.extras[1]?.length > 0" :style="{
					color: '#ff5e2a'
				}" _cursor="pointer" @click="previewEditBefore">预览编辑</span>
				<span _text="[#ff1f3b] 12px bolder" _flex="~" _p="t-16px" v-if="errorTipVisibe">未识别谱例</span>
				<div _m="y-10px" _p="10px" _flex="~" _border="solid 1px [#DCDCDC] rounded-[4px]"
					v-if="ruleForm.extras[1]?.length > 0">
					<div v-for="element in ruleForm.extras[1]" :key="element.midi" _m="r-25px" _bg="![#9C9C9C]" _w="45px"
						_h="45px" _text="16px white" _flex="~ justify-center items-center" _border="rounded-[4px]"
						style="box-shadow:0 0 3px 3px #DCDCDC">
						{{ element.cm?.toLowerCase() }}
					</div>
				</div>
			</el-form-item>
			<el-form-item label="干扰项" v-if="singFormFlag && ruleForm.type == 18 && ruleForm.extras[1]">
				<InputTopTip v-model="textValue" placeholder="请选择添加干扰音符" :marginTop="13">
					<el-select v-model="textValue" multiple placeholder="" class="width-453" @change="genealogyAdd">
						<el-option v-for="item in ruleForm.extras[3]" :key="item.cm" :label="item.cm.toLowerCase()"
							:value="item.cm">
						</el-option>
					</el-select>
				</InputTopTip>
				<div _m="t-10px" _p="x-10px t-10px" _flex="~ wrap" _border="solid 1px [#DCDCDC] rounded-[4px]"
					v-if="ruleForm.extras[2]?.length > 0">
					<div v-for="(element, index) in ruleForm.extras[2] || []" :key="element?.cm || index" _m="r-25px b-10px"
						_bg="![#9C9C9C]" _text="16px white" _w="45px" _h="45px" _flex="~ justify-center items-center"
						style="box-shadow:0 0 5px 3px #DCDCDC" _border="rounded-[4px]" _pos="relative">
						<!-- <div _w="16px" _flex="~ justify-center items-center" _text="14px" _h="16px" _bg="[#CFD7E7]" _cursor="pointer" _border="rounded-[100px]" _pos="absolute" _top="0" _right="0" _transform="~ translate-x-[30%] translate-y-[-30%]" @click="ruleForm.extras[2].splice(index, 1)">
              <i class="el-icon-close"></i>
            </div> -->
						{{ element?.cm?.toLowerCase() }}
					</div>
				</div>
			</el-form-item>

			<el-form-item label="解析" prop="explain"
				v-if="!singFormFlag && !matchColorVisible && !puzzleVisible && ![10, 12].includes(ruleForm.type)">
				<quillText class="quill-text" :content="ruleForm.explain" @changeContent="updateContent('explain', $event)"
					placeholder="暂无解析" />
			</el-form-item>

			<el-form-item label="颜色组合" prop="correctColor" v-if="matchColorVisible" :rules="matchColorRules">
				<div>
					<match-color :interfereColor="matchColor[1]" v-model="matchColor[0]" />
					<div _p="l-10px" _text="[#666666]" _bg="[#F9F9F9]" :style="{
						borderLeft: 'solid rgba(0, 0, 0, 0.2) 1px',
						borderRight: 'solid rgba(0, 0, 0, 0.2) 1px',
					}" _w="733px">可填入颜色</div>
					<fill-color :correct-color.sync="matchColor[0]" v-model="matchColor[1]" />
				</div>
			</el-form-item>

			<el-form-item label="拼图数量" prop="puzzleNum" v-if="puzzleVisible">
				<el-select v-model="puzzle.num" :controls="false">
					<el-option v-for="item in [4, 9, 16]" :key="item" :label="item" :value="item"> </el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="拼图图片" prop="puzzlePic" v-if="puzzleVisible">
				<puzzle v-model="puzzle.pic" :num="puzzle.num" />
			</el-form-item>


			<el-form-item label="自由填色" v-if="mappingVisible">
				<el-switch v-model="ruleForm.extras[1]" :width="32"></el-switch>
				<div style="font-size: 12px; color: #999999; margin-left: 10px;">
					* 打开则题目为主观题,需要人工判分; 关闭则每个填色区有唯一标准正确答案颜色
				</div>
			</el-form-item>
			<el-form-item label="原图与填充图" prop="color" v-if="mappingVisible">
				<colorFill :question="ruleForm" @changeQuestion="changeColorFillQuestion" />
			</el-form-item>

			<el-form-item label="带提示" prop="color" v-if="puzzleVisible">
				<el-switch v-model="puzzle.tip" />
				<div style="font-size: 12px; line-height: 28px; color: #b7b7b7;">打开提示按钮后，做题区域背景会有答案提示</div>
			</el-form-item>

			<div class="form-item-title" v-if="!matchColorVisible && !puzzleVisible">题目属性</div>
			<el-form-item label="知识点" prop="knowledge_point">
				<InputTopTip v-model="ruleForm.knowledge_point" placeholder="知识点" :marginTop="14">
					<el-cascader v-model="ruleForm.knowledge_point" :options="konwPointTags" clearable placeholder=""
						@change="handleChange" :show-all-levels="false" filterable :props="{
							value: 'id',
							label: 'knowledge_name',
							children: 'knowledges',
							expandTrigger: 'click',
							emitPath: false,
							filterable: true,
							multiple: true
						}" class="width-453 form-item-cascader">
					</el-cascader>
				</InputTopTip>
			</el-form-item>
			<el-form-item label="能力点" prop="competence">
				<InputTopTip v-model="ruleForm.competence" placeholder="能力点" :marginTop="14">
					<el-select filterable multiple v-model="ruleForm.competence" placeholder="" class="width-453" clearable>
						<el-option v-for="item in powerPointTags" :key="item.knowledge_name" :label="item.knowledge_name"
							:value="item.id">
						</el-option>
					</el-select>
				</InputTopTip>
			</el-form-item>
			<el-form-item label="难度" prop="difficulty">
				<el-radio-group v-model="ruleForm.difficulty">
					<el-radio v-for="item in difficultyList" :key="item.label" :label="item.label" :value="item.label"></el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="查看权限" prop="is_public">
				<el-radio-group v-model="ruleForm.is_public">
					<el-radio-button :label="0" :value="0" :key="0">私有题目</el-radio-button>
					<el-radio-button :label="1" :value="1" :key="1">公开题目</el-radio-button>
				</el-radio-group>
				<div _text="[#000000]" _opacity="[0.5]">
					非私有可用题目范围，其他符合条件范围的学生、教师都可以使用于测试和练习
				</div>
			</el-form-item>

			<div class="form-item-title" _transform="~ translate-x-[-62px]" _flex="~ items-center" _gap="x-10px">
				<div _flex="~ items-center">题型赋分设置
					<el-popover placement="bottom-start" trigger="hover" popper-class="value-tip">
						<img :src="require('@/assets/value-tip.png')" style="width: 350px" />
						<svg slot="reference" _ml="5px" width="14" height="14" viewBox="0 0 14 14" fill="#525252" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer;">
							<path
								d="M9.45 5.34333C9.415 5.97917 9.2225 6.475 8.24834 7.44333C7.75834 7.93333 7.44334 8.30667 7.41417 8.61C7.40253 8.73171 7.34581 8.84466 7.25514 8.92669C7.16448 9.00872 7.04643 9.05389 6.92417 9.05333H6.8775C6.81305 9.04749 6.75038 9.02893 6.69314 8.99874C6.63589 8.96854 6.5852 8.92731 6.54398 8.87741C6.50276 8.82751 6.47183 8.76994 6.45298 8.70802C6.43414 8.64611 6.42774 8.58107 6.43417 8.51667C6.60495 7.8155 7.01045 7.19386 7.58334 6.755C8.46417 5.87417 8.48167 5.58833 8.49334 5.29667C8.50128 5.12275 8.47326 4.94906 8.41103 4.78646C8.3488 4.62386 8.2537 4.47584 8.13167 4.35167C7.98618 4.19826 7.81055 4.07658 7.61581 3.99427C7.42107 3.91196 7.21141 3.87078 7 3.87333C6.61014 3.87333 6.23624 4.02821 5.96056 4.30389C5.68488 4.57957 5.53 4.95346 5.53 5.34333C5.53 5.47406 5.47807 5.59944 5.38563 5.69188C5.29319 5.78432 5.16782 5.83625 5.03709 5.83625C4.90636 5.83625 4.78098 5.78432 4.68854 5.69188C4.5961 5.59944 4.54417 5.47406 4.54417 5.34333C4.55185 4.69707 4.81397 4.07989 5.2737 3.62562C5.73343 3.17135 6.3537 2.91662 7 2.91667C7.34235 2.91603 7.68125 2.98499 7.99613 3.11936C8.311 3.25373 8.59527 3.45071 8.83167 3.69833C9.04058 3.91649 9.20309 4.17474 9.30937 4.45748C9.41565 4.74022 9.46349 5.04158 9.45 5.34333ZM6.9125 11.0833C6.79713 11.0833 6.68435 11.0491 6.58842 10.985C6.49249 10.9209 6.41773 10.8298 6.37357 10.7232C6.32942 10.6166 6.31787 10.4994 6.34038 10.3862C6.36289 10.273 6.41844 10.1691 6.50002 10.0875C6.5816 10.0059 6.68554 9.95038 6.7987 9.92787C6.91186 9.90537 7.02915 9.91692 7.13574 9.96107C7.24233 10.0052 7.33343 10.08 7.39753 10.1759C7.46163 10.2718 7.49584 10.3846 7.49584 10.5C7.49584 10.6547 7.43438 10.8031 7.32498 10.9125C7.21559 11.0219 7.06721 11.0833 6.9125 11.0833ZM7 0C5.61553 0 4.26216 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.00303297 5.6003 -0.13559 7.00776 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C14 5.14348 13.2625 3.36301 11.9498 2.05025C10.637 0.737498 8.85652 0 7 0Z"
								fill="#525252" />
						</svg>
					</el-popover>
				</div>
				<div>
				</div>
				<el-switch v-model="ruleForm.is_evaluation_switch" :active-value="1" :inactive-value="0" :width="40" />
				<div _text="12px [#b7b7b7]">提示：后台开关开启可设置本道题的答题情况与赋分,老师设置对应题目的答题情况正确率,学生作答后获取对应的题型赋分；例如：单选题正确率(100%),赋分(3)学生回答正确后可以获取3分。</div>
			</div>

			<el-form-item prop="evaluationScoreRows" :rules="evaluationScoreRules" v-if="ruleForm.is_evaluation_switch === 1"
				class="evaluation-form-item">
				<div>
					<!-- 表现分编辑区域 -->
					<div class="evaluation-score-table">
						<!-- 表头 -->
						<div class="table-header">
							<div class="table-cell">正确率（%）</div>
							<div class="table-cell">赋分（分）</div>
							<div class="table-cell">操作</div>
						</div>

						<!-- 表格行 -->
						<div class="table-body">
							<div v-for="(row, index) in ruleForm.evaluationScoreRows" :key="row._uid" class="table-row">
								<div class="table-cell">
									<el-input v-model="row.percentage" size="small" placeholder="请输入"
										:class="{ 'is-error': row.percentageError }" @input="handlePercentageInput(index)"
										@blur="handlePercentageBlur(index)" />
								</div>
								<div class="table-cell">
									<el-input v-model="row.score" size="small" placeholder="请输入" :class="{ 'is-error': row.scoreError }"
										@input="handleScoreInput(index)" @blur="handleScoreBlur(index)" />
								</div>
								<div class="table-cell">
									<span class="delete-btn" @click="handleDeleteEvaluationRow(index)"><svg width="32" height="32"
											viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
											<rect width="32" height="32" rx="4" fill="#FFF1F1" />
											<path d="M10 11.5703L22 11.5703" stroke="#FF1F1F" stroke-linecap="round" />
											<path
												d="M11.7109 13.2891V19.8605C11.7109 20.9651 12.6064 21.8605 13.7109 21.8605H18.2824C19.3869 21.8605 20.2824 20.9651 20.2824 19.8605V13.2891"
												stroke="#FF1F1F" stroke-linecap="round" />
											<path
												d="M19.4297 11.5703V9.99888C19.4297 9.4466 18.982 8.99888 18.4297 8.99888H13.5725C13.0203 8.99888 12.5725 9.4466 12.5725 9.99888V11.5703"
												stroke="#FF1F1F" stroke-linecap="round" />
											<path d="M14.2891 13.2891V19.2891" stroke="#FF1F1F" stroke-linecap="round" />
											<path d="M17.7109 13.2891V19.2891" stroke="#FF1F1F" stroke-linecap="round" />
										</svg>
									</span>
								</div>
							</div>
						</div>

						<!-- 添加按钮 -->
						<div class="table-footer" _flex="~ justify-end">
							<div class="add-btn" @click="handleAddEvaluationRow">
								<svg width="70" height="33" viewBox="0 0 70 33" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect width="70" height="33" rx="4" fill="#FFF4F0" />
									<path
										d="M38.62 11.122H46.446V12.06H42.638C42.4793 12.76 42.316 13.348 42.148 13.824H47.062V14.79H44.122C44.85 15.9287 45.97 16.82 47.482 17.464L47.048 18.346C45.1907 17.4407 43.8747 16.2553 43.1 14.79H41.756C41.6627 14.9767 41.5227 15.238 41.336 15.574C40.6267 16.6473 39.5673 17.6133 38.158 18.472L37.528 17.674C38.844 16.9553 39.8427 16.0827 40.524 15.056L40.692 14.79H37.976V13.824H41.14C41.3453 13.3107 41.5087 12.7227 41.63 12.06H38.62V11.122ZM40.314 18.92C39.7913 20.3573 39.1893 21.5987 38.508 22.644L37.682 22.056C38.382 21.0387 38.9793 19.858 39.474 18.514L40.314 18.92ZM35.61 10.758C36.478 11.3553 37.2293 11.9713 37.864 12.606L37.178 13.292C36.646 12.732 35.89 12.1067 34.91 11.416L35.61 10.758ZM35.274 14.104C36.226 14.8227 36.996 15.518 37.584 16.19L36.884 16.876C36.3147 16.2133 35.5493 15.5087 34.588 14.762L35.274 14.104ZM37.444 18.318C36.8933 20.082 36.2773 21.7527 35.596 23.33L34.658 22.91C35.414 21.2393 36.0487 19.592 36.562 17.968L37.444 18.318ZM40.006 23.414L39.796 22.462C40.244 22.5087 40.6313 22.532 40.958 22.532C41.2473 22.532 41.392 22.3453 41.392 21.972V16.848H42.358V22.21C42.358 23.0127 42.008 23.414 41.308 23.414H40.006ZM45.634 18.178C46.306 19.4473 46.8753 20.7773 47.342 22.168L46.446 22.56C45.914 20.9733 45.3493 19.6107 44.752 18.472L45.634 18.178ZM43.786 18.682C44.3647 19.886 44.8733 21.202 45.312 22.63L44.416 23.036C43.968 21.496 43.4733 20.1427 42.932 18.976L43.786 18.682ZM60.698 12.326V23.19H59.718V22.266H57.198V23.19H56.218V12.326H60.698ZM57.198 21.286H59.718V13.306H57.198V21.286ZM51.01 10.604H52.046V13.04H54.916C54.916 17.6227 54.846 20.4553 54.706 21.538C54.566 22.6953 53.8707 23.274 52.62 23.274L51.556 23.218L51.304 22.294C51.9013 22.3313 52.2933 22.35 52.48 22.35C53.2173 22.35 53.642 21.9487 53.754 21.146C53.838 20.362 53.894 17.9867 53.922 14.02H52.046V14.286C51.9993 18.4767 51.0847 21.5427 49.302 23.484L48.49 22.756C50.142 21.0107 50.982 18.1873 51.01 14.286V14.02H48.784V13.04H51.01V10.604Z"
										fill="#FF5E2A" />
									<path
										d="M22.625 10.25H11.375C10.7537 10.25 10.25 10.7537 10.25 11.375V22.625C10.25 23.2463 10.7537 23.75 11.375 23.75H22.625C23.2463 23.75 23.75 23.2463 23.75 22.625V11.375C23.75 10.7537 23.2463 10.25 22.625 10.25Z"
										stroke="#FF5E2A" stroke-linejoin="round" />
									<path d="M17 14V20" stroke="#FF5E2A" stroke-linecap="round" stroke-linejoin="round" />
									<path d="M14 17H20" stroke="#FF5E2A" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<span _pos="absolute" _right="11px" _leading="34px">添加</span>
							</div>
						</div>
				</div>
			</div>
			</el-form-item>

			<div class="form-item-title">应用范围</div>
			<el-form-item label-width="85px" prop="scopeTable">
				<el-table :data="scopeTable" border style="width: 1040px;" class="scope-table">
					<el-table-column label="学段" prop="school_stage" width="110px" align="center">
						<template slot-scope="scope">
							<InputTopTip v-model="scope.row.school_stage" placeholder="学段" :marginTop="12">
								<el-select v-model="scope.row.school_stage" placeholder="" size="small"
									@change="scopeChange($event, scope)">
									<el-option v-for="item in section" :key="item.val" :label="item.name" :value="item.val"> </el-option>
								</el-select>
							</InputTopTip>
						</template>
					</el-table-column>
					<el-table-column label="出版社" prop="publisher_id" width="150px" align="center">
						<template slot-scope="scope">
							<InputTopTip v-model="scope.row.publisher_id" placeholder="出版社" :marginTop="12">
								<el-select v-model="scope.row.publisher_id" :disabled="scope.row.school_stage === ''" placeholder=""
									size="small" @change="scopeChange($event, scope)">
									<el-option v-for="item in publisherIdTags[scope.$index]" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</InputTopTip>
						</template>
					</el-table-column>
					<el-table-column label="教材" prop="textbook_id" width="150px" align="center">
						<template slot-scope="scope">
							<InputTopTip v-model="scope.row.textbook_id" placeholder="教材" :marginTop="12">
								<el-select v-model="scope.row.textbook_id"
									:disabled="scope.row.publisher_id === '' || scope.row.publisher_id == 0 || (scope.row.school_stage == 0 && scope.row.publisher_id != 0)"
									placeholder="" size="small" @change="scopeChange($event, scope)">
									<el-option v-for="item in textbook[scope.$index]" :key="item.id" :label="item.text_name"
										:value="item.id">
									</el-option>
								</el-select>
							</InputTopTip>
						</template>
					</el-table-column>
					<el-table-column label="年级" prop="apply_grade" width="150px" align="center">
						<template slot-scope="scope">
							<InputTopTip v-model="scope.row.apply_grade" placeholder="年级" :marginTop="12">
								<el-select disabled v-model="scope.row.apply_grade" placeholder="" size="small"
									@change="scopeChange($event, scope)">
									<el-option v-for="item in scopeGrade" :key="item.val" :label="item.name" :value="item.val">
									</el-option>
								</el-select>
							</InputTopTip>
						</template>
					</el-table-column>
					<el-table-column label="学期" prop="apply_volume" width="150px" align="center">
						<template slot-scope="scope">
							<InputTopTip v-model="scope.row.apply_volume" placeholder="学期" :marginTop="12">
								<el-select disabled v-model="scope.row.apply_volume" placeholder="" size="small"
									@change="scopeChange($event, scope)">
									<el-option v-for="item in scopeVolume" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
							</InputTopTip>
						</template>
					</el-table-column>
					<el-table-column label="目录" prop="dict_ids" width="180px" align="center">
						<template slot-scope="scope">
							<InputTopTip v-model="scope.row.dict_ids" placeholder="目录" :marginTop="12">
								<el-cascader v-model="scope.row.dict_ids" :props="{
									value: 'id',
									label: 'direct_name',
									expandTrigger: 'click',
									multiple: true
								}" :options="scopeOptions[scope.$index]" :show-all-levels="false"
									:disabled="scope.row.apply_volume == '' || scope.row.textbook_id == 0" placeholder="" size="small"
									collapse-tags @change="scopeChange($event, scope)"></el-cascader>
							</InputTopTip>
							<!-- <el-select v-model="scope.row.dict_ids" :disabled="!!!scope.row.e" @change="scopeChange($event, scope)">
								<el-option v-for="item in section" :key="item.val" :label="item.name" :value="item.val"> </el-option>
							</el-select> -->
						</template>
					</el-table-column>
					<el-table-column label="操作" width="150px" align="center">
						<template slot-scope="{ row, $index }">
							<el-button type="danger" size="small" plain icon="el-icon-delete"
								@click="deleteScope(row, $index)"></el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="scope-button">
					<el-button size="small" style="background: #f7f8fa;" @click="deleteAllScope"
						icon="el-icon-circle-close">清空</el-button>
					<el-button size="small" plain type="primary" @click="addScope"
						icon="el-icon-circle-plus-outline">添加</el-button>
				</div>
			</el-form-item>
			<el-form-item style="margin-top: 80px;">
				<div style="max-width: 1100px;" _flex="~ justify-center">
					<el-button style="width: 294px; margin-right: 20px;" size="small" @click="routeBack('')">取消</el-button>
					<el-button type="primary" size="small" style="width: 294px;" :loading="submitFormLoading"
						@click="submitForm('ruleForm')">保存</el-button>
				</div>
			</el-form-item>
		</el-form>
		<template v-if="ruleForm.type === 9">
			<SingGenealogy v-model="singGenealogyVisible" :questionType="ruleForm.type" @select="genealogySelect" />
		</template>
		<template v-if="ruleForm.type !== 9">
			<genealogy v-model="genealogyVisible" :questionType="ruleForm.type" @select="genealogySelect" />
		</template>
		<previewEdit v-model="previewEdit.visible" :data="previewEdit" :reset="previewEditReset" />
	</div>
</template>
<script>
import upload from './VisualQuestionEditor/upload.vue'
import connectLine from './connectLine.vue'
import quillText from './quillText.vue'
import quillTextLight from './quillTextLight.vue'
import genealogy from './genealogy.vue'
import SingGenealogy from './SingGenealogy.vue'
import matchColorComponent from './matchColor.vue'
import fillColor from './fillColor.vue'
import puzzle from './puzzle.vue'
import art from './art.vue'
import music from './music.vue'
import colorFill from './colorFill.vue'
import previewEdit from './previewEdit.vue'
import {
	fb_apply_volume,
	difficultyList,
	primarySchool,
	middleSchool,
	highSchool,
	all_grade,
	section,
	questionType,
	audioTypes,
	noteMap,
	sameMidiNoteMap,
	spectralPlaneMap
} from './const'
import getRules from './rules.js'
import { last } from 'lodash'
import abcjs from "abcjs"
export default {
	components: {
		previewEdit,
		upload,
		connectLine,
		quillText,
		quillTextLight,
		genealogy,
		SingGenealogy,
		matchColor: matchColorComponent,
		fillColor,
		puzzle,
		art,
		music,
		colorFill
	},
	watch: {},
	data() {
		return {
			errorTipVisibe: false, // 表单额外校验字段展示错误信息
			spectralPlaneMap,
			sameMidiNoteMap,
			previewEdit: {
				seeVisible: false,
				visible: false,
				musical_id: '',
				midiNoteMap: [],
				allNoteMap: [],
				musciData: {}
			},
			noteMap,
			audioTypes,
			section,
			scopeTable: [],
			all_grade,
			rules: getRules(this),
			body: '',
			placeholder: '',
			items: {
				// left: ["项目A", "项目B"],
				// right: ["关联A", "关联B", "关联C"]
				left: [],
				right: []
			},
			connections: [
				// [0],[1,2]
			],
			style: {},
			// 临时文件
			echoFile: [],
			ruleForm: {
				format: 'raw',
				type: '',
				body: '',
				branches: [] || {},
				answer: null || [] || {},
				score: '',
				explain: '',
				knowledge_point: [],
				competence: [],
				difficulty: '',
				extras: [],
				publisher_id: '',
				apply_volume: '',
				apply_grade: '',
				subject_id: '',
				media: [],
				is_public: 0,
				scope: [],
				musical_id: '',
				musical_offset: 0,
				is_evaluation_switch: 0,
				evaluationScoreRows: []
			},
			// 文件格式
			fileAccept: '',
			// 单选~多选~填空
			list: [],
			// 选择题类型
			radioFormFlag: false,
			moreRadioFormFlag: false,
			gapFormFlag: false,
			connectFormFlag: false,
			genealogyVisible: false,
			singGenealogyVisible: false,
			singFormFlag: false,
			insertingFlag: false,
			matchColorVisible: false,
			puzzleVisible: false,
			mappingVisible: false,
			artisticFeaturesVisible: false,
			musicalFeatureVisible: false,
			// 数据
			apply_grade: [],
			typeList: [],
			fb_apply_volume: [],
			difficultyList: [],
			konwPointTags: [],
			powerPointTags: [],
			publisherIdTags: [],
			textbook: [],
			scopeGrade: [],
			scopeVolume: [],
			scopeOptions: [],
			// 表现分验证规则
			evaluationScoreRules: [{
				validator: (rule, value, callback) => {
					if (this.ruleForm.is_evaluation_switch !== 1) {
						callback()
						return
					}
					const result = this.getValidEvaluationScore()
					if (result === null) {
						callback(new Error('表现分数据不完整或存在重复百分比'))
					} else {
						callback()
					}
				}
			}],
			// 计数器生成键值重复
			index: 0,
			matchColorRules: [{
				validator: (rule, value, callback) => {
					if (this.matchColor[0].length < 2) {
						callback(new Error(`颜色数量不能小于2`))
					} else if (this.matchColor[0].length >= this.matchColor[1].length) {
						callback(new Error(`未添加干扰项`))
					} else {
						callback()
					}
				}
			}],
			// 配色 填充 拼图 抓气球
			matchColor: [[], []],
			// 拼图
			puzzle: {
				num: 4,
				pic: '',
				tip: false
			},
			mapping: {
				pic: ''
			},
			artisticFeatures: [[], []],
			musicalFeature: [[], []],
			scope_type: '',
			submitFormLoading: false, // 提交按钮loading
			textValue: [] // 无所谓参数
		}
	},
	methods: {
		changePositionClick(positionType, positionIndex) {
			if ((positionIndex == this.list.length - 1 && positionType == 'down') || (positionType == 'up' && positionIndex == 0)) {
				return
			}
			if (positionType == 'down') {
				this.list.splice(positionIndex + 1, 0, this.list.splice(positionIndex, 1)[0])
			} else {
				this.list.splice(positionIndex - 1, 0, this.list.splice(positionIndex, 1)[0])
			}
		},
		getUUID() {
			const tempURL = URL.createObjectURL(new Blob())
			const uuid = tempURL.toString()
			URL.revokeObjectURL(tempURL)
			return last(uuid.split('/'))
		},
		async previewEditBefore() {
			if (this.previewEdit.seeVisible) {
				this.previewEdit.midiNoteMap = this.ruleForm.extras[1]
				this.previewEdit.musical_id = this.ruleForm.musical_id
				this.previewEdit.visible = true
			} else {
				await this.genealogySee()
				this.previewEditBefore()
			}
		},
		// 预览编辑重置干扰项
		previewEditReset({ correct, error }) {
			this.ruleForm.extras[3] = error
			this.$set(this.ruleForm.extras, 2, [])
			this.$set(this.ruleForm.extras, 1, correct)
		},
		// 干扰项添加
		genealogyAdd(cm) {
			this.ruleForm.extras[2] = this.ruleForm.extras[3].filter(item => cm.includes(item.cm))
		},
		// 乐谱识别
		async genealogySee() {
			this.errorTipVisibe = false
			this.previewEdit.seeVisible = true
			const loading = this.$loading({
				lock: true,
				text: '正在识别中',
				spinner: 'el-icon-loading'
			})
			const musciData = await this.$api.question_set.getMusicalsDetail(
				this.ruleForm.musical_id
			)
			const { abc_json_val, music, base_info } = musciData
			const abcContent = await this.$http({ url: abc_json_val.url })
			const vocalJson = music.reduce(
				(vocalJson, item, i) => {
					let code
					if (item?.audio_type > 10) { // 小于10的需要自己映射
						code = item?.type?.title
					} else {
						code = this.audioTypes[music[i]?.audio_type]?.CODE
					}
					// const code = this.audioTypes[music[i].audio_type].CODE
					vocalJson[code + '_URL'] = music[i].file_path.url
					const new_timeline = JSON.parse(music[i].new_timeline || '{}')
					vocalJson[code + '_WXP_BARLINE'] = new_timeline?.NODELINE_WXP ? new_timeline.NODELINE_WXP : ''
					// @ts-ignore 是否显示倒计时（预备拍)
					vocalJson[`${code}_COUNTDOWN_USE_METER`] = item.extra?.countdownUseMeter
					return vocalJson
				},
				{
					ABC_CONTENT: abcContent,
					SHOW_TYPE: base_info.musicType === 'easy' ? 'jp' : 'wxp'
				}
			)
			const [abcInts] = abcjs.parseOnly(vocalJson.ABC_CONTENT)
			const midiToNoteNameInKey = (midi, key) => {
				const solfegeNamesSharp = ['Do', '#Do', 'Re', '#Re', 'Mi', 'Fa', '#Fa', 'Sol', '#Sol', 'La', '#La', 'Si'];
				const solfegeNamesFlat = ['Do', '♭Re', 'Re', '♭Mi', 'Mi', 'Fa', '♭Sol', 'Sol', '♭La', 'La', '♭Si', 'Si'];
				const keyShifts = {
					'C': 0, 'G': 7, 'D': 2, 'A': 9, 'E': 4, 'B': 11,
					'F#': 6, 'C#': 1, 'G#': 8, 'D#': 3, 'A#': 10,
					'F': 5, 'Bb': 10, 'Eb': 3, 'Ab': 8, 'Db': 1, 'Gb': 6
				};
				const keyShift = keyShifts[key] || 0;
				const noteIndex = (midi % 12 - keyShift + 12) % 12; // 确保索引为正
				// 根据调号选择使用升音还是降音的音名
				// const useSharps = ['C', 'G', 'D', 'A', 'E', 'B', 'F#', 'C#', 'G#', 'D#', 'A#'].includes(key);
				const useFlats = ['F', 'Bb', 'Eb', 'Ab', 'Db', 'Gb'].includes(key);
				const solfegeNames = useFlats ? solfegeNamesFlat : solfegeNamesSharp;
				return solfegeNames[noteIndex];
			}
			const noteNameToMidiToInKey = (key, solfege, octave) => {
				const noteToMIDI = {
					'C': 60, 'C#': 61, 'Db': 61, 'D': 62, 'D#': 63, 'Eb': 63,
					'E': 64, 'F': 65, 'F#': 66, 'Gb': 66, 'G': 67, 'G#': 68,
					'Ab': 68, 'A': 69, 'A#': 70, 'Bb': 70, 'B': 71
				};
				const solfegeOffsets = {
					'Do': 0, 'Re': 2, 'Mi': 4, 'Fa': 5, 'Sol': 7, 'La': 9, 'Si': 11,
					'#Do': 1, '#Re': 3, '#Mi': 5, '#Fa': 6, '#Sol': 8, '#La': 10, '#Si': 12,
					'♭Do': -1, '♭Re': 1, '♭Mi': 3, '♭Fa': 4, '♭Sol': 6, '♭La': 8, '♭Si': 10,
					'xDo': 2, 'xRe': 4, 'xMi': 6, 'xFa': 7, 'xSol': 9, 'xLa': 11, 'xSi': 1,
					'♭♭Do': 10, '♭♭Re': 0, '♭♭Mi': 2, '♭♭Fa': 3, '♭♭Sol': 5, '♭♭La': 7, '♭♭Si': 9,
				};
				const baseMIDI = noteToMIDI[key];
				const offset = solfegeOffsets[solfege]; // 获取半音偏移
				if (offset === undefined) {
					throw new Error('Invalid solfege name');
				}
				const midi = baseMIDI + offset + (octave - 4) * 12;
				return midi;
			}
			const filterUniqueMidi = (data, key) => {
				const seenMidiValues = new Set();
				const uniqueData = [];
				for (const item of data) {
					if (!seenMidiValues.has(item[key])) {
						uniqueData.push(item);
						seenMidiValues.add(item[key]);
					}
				}
				return uniqueData;
			}
			const key = base_info.keySign
			const tracks = filterUniqueMidi(filterUniqueMidi(
				abcInts.setUpAudio({}).tracks.flat(Infinity).filter((item) => item.cmd === 'note'), 'pitch'
			).map(item => {
				console.log('item', item)
				return {
					midi: item.pitch,
					cm: midiToNoteNameInKey(item.pitch, key),
					type: 'info',
					...item,
					cms: this.sameMidiNoteMap[item.cm]
				}
			}), 'cm')
			const noteMap = this.noteMap.filter(item => {
				return tracks.every(e => e.cm != item)
			}).map((item) => {
				return {
					cm: item,
					midi: noteNameToMidiToInKey(key, item, 4),
					pitch: noteNameToMidiToInKey(key, item, 4),
					type: 'error',
					cmd: 'note',
					duration: '0.5',
					instrument: 0,
					volume: 100,
					gap: 0
				}
			})
			await new Promise((resolve) => { setTimeout(() => { resolve() }, 500) })
			this.ruleForm.extras[3] = noteMap
			this.$set(this.ruleForm.extras, 2, [])
			this.$set(this.ruleForm.extras, 1, tracks)
			this.textValue = []
			this.previewEdit.vocalJson = vocalJson
			this.previewEdit.musciData = musciData
			this.previewEdit.allNoteMap = [...noteMap, ...tracks]
			loading.close()
		},
		// 谱例插入
		genealogySelect({ selectId, name }) {
			this.$set(this.ruleForm, 'musical_id', selectId)
			this.$set(this.ruleForm.extras, 0, name)
			if (this.ruleForm.type == 4) {
				this.$set(this.ruleForm.extras, 1, 'jp')
			}
		},
		async getTextbooks({ publisher_id, school_stage }, index) {
			const { data } = await this.$api.resource.getTextbooks({
				fb_subject_id: this.ruleForm.subject_id,
				fb_publisher_id: publisher_id == 0 ? '' : publisher_id,
				school_stage: school_stage == 0 ? '' : school_stage,
				// scope_type: this.scope_type,
				scope_type: 0,
				page_size: 998,
				page: 1
			})
			if (data.length >= 2) {
				this.$set(this.textbook, index, [{ id: 0, text_name: '全部' }, ...data])
			} else {
				this.$set(this.textbook, index, data)
			}
		},
		removeEmptyItems(arr) {
			const newArr = []
			for (let i = 0; i < arr.length; i++) {
				const item = arr[i]
				if (item.children?.length >= 1) {
					item.children = this.removeEmptyItems(item.children)
				} else {
					item.children = undefined
				}
				newArr.push(item)
			}
			return newArr
		},
		addEmptyItems(arr, visible) {
			const newArr = []
			for (let i = 0; i < arr.length; i++) {
				const item = arr[i]
				if (item.children?.length >= 1) {
					item.children = this.addEmptyItems(item.children, visible)
				} else {
					item.children = undefined
				}
				if (item.id !== 0) {
					item.disabled = visible
				} else {
					item.disabled = false
				}
				newArr.push(item)
			}
			return newArr
		},
		async scopeChange(e, scope) {
			const { column, $index, row } = scope
			switch (column.label) {
				case '学段':
					this.$set(this.scopeTable, $index, {
						school_stage: row.school_stage,
						publisher_id: '',
						textbook_id: '',
						apply_grade: '',
						apply_volume: '',
						dict_ids: []
					})
					this.getPublisherId(e, $index)
					break
				case '出版社':
					if (e !== 0) {
						if (this.scopeTable[$index].school_stage == 0 || e == 0) {
							this.$set(this.textbook, $index, [{ id: 0, text_name: '全部' }])
							this.$set(this.scopeOptions, $index, [{ id: 0, direct_name: '全部', children: undefined }])
							this.scopeGrade = [{ name: '全部', val: 0 }]
							this.scopeVolume = [{ label: '全部', value: 0 }]
							this.$set(this.scopeTable, $index, {
								school_stage: row.school_stage,
								publisher_id: row.publisher_id,
								textbook_id: 0,
								apply_grade: 0,
								apply_volume: 0,
								dict_ids: [[0]]
							})
						} else {
							this.$set(this.scopeTable, $index, {
								school_stage: row.school_stage,
								publisher_id: row.publisher_id,
								textbook_id: '',
								apply_grade: '',
								apply_volume: '',
								dict_ids: []
							})
							this.getTextbooks(
								{
									school_stage: row.school_stage,
									publisher_id: row.publisher_id
								},
								$index
							)
						}
					}
					else {
						this.$set(this.textbook, $index, [{ id: 0, text_name: '全部' }])
						this.$set(this.scopeOptions, $index, [{ id: 0, direct_name: '全部', children: undefined }])
						this.scopeGrade = [{ name: '全部', val: 0 }]
						this.scopeVolume = [{ label: '全部', value: 0 }]
						this.$set(this.scopeTable, $index, {
							school_stage: row.school_stage,
							publisher_id: row.publisher_id,
							textbook_id: 0,
							apply_grade: 0,
							apply_volume: 0,
							dict_ids: [[0]]
						})
					}
					break
				case '教材': {
					if (e !== 0) {
						let book = this.textbook[$index].find(item => item.id == row.textbook_id)
						this.scopeGrade = [this.all_grade.find(item => item.val == book.text_classgrade)]
						this.scopeVolume = [this.fb_apply_volume.find(item => item.value == book.text_volume)]
						const options = this.removeEmptyItems(book?.directory, 'children')
						// this.scopeOptions[$index] = options
						this.$set(this.scopeTable, $index, {
							school_stage: row.school_stage,
							publisher_id: row.publisher_id,
							textbook_id: row.textbook_id,
							apply_grade: book.text_classgrade,
							apply_volume: book.text_volume,
							dict_ids: []
						})
						if (options.length >= 2) {
							this.scopeOptions[$index] = [{ id: 0, direct_name: '全部', children: undefined }, ...options]
						} else {
							this.scopeOptions[$index] = options
						}
					} else {
						// 选中全部教材就不能选目录，不然无法回显
						let books = this.textbook[$index].slice(1)
						const options = books
							.map(book => {
								return this.removeEmptyItems(book?.directory, 'children')
							})
							.reduce((acc, current) => acc.concat(current), [])
						// 改成多选，而不是全选的单选项
						options.unshift({ id: 0, direct_name: '全部', children: undefined })
						this.scopeOptions[$index] = options
						this.scopeGrade = [{ name: '全部', val: 0 }]
						this.scopeVolume = [{ label: '全部', value: 0 }]
						this.$set(this.scopeTable, $index, {
							school_stage: row.school_stage,
							publisher_id: row.publisher_id,
							textbook_id: row.textbook_id,
							apply_grade: 0,
							apply_volume: 0,
							dict_ids: [[0]]
						})
					}
					break
				}
				case '年级':
					this.$set(this.scopeTable, $index, {
						school_stage: row.school_stage,
						publisher_id: row.publisher_id,
						textbook_id: row.textbook_id,
						apply_grade: row.apply_grade,
						apply_volume: '',
						dict_ids: []
					})
					break
				case '学期':
					this.$set(this.scopeTable, $index, {
						school_stage: row.school_stage,
						publisher_id: row.publisher_id,
						textbook_id: row.textbook_id,
						apply_grade: row.apply_grade,
						apply_volume: row.apply_volume,
						dict_ids: []
					})
					break
				case '目录': {
					const all = e.reduce((acc, current) => acc.concat(current), [])
					const isAll = all.includes(0)
					let filterE = e
					if (isAll) {
						this.scopeOptions[$index] = this.addEmptyItems(this.scopeOptions[$index], isAll)
						filterE = e.filter(subArray => subArray.includes(0))
					} else {
						this.scopeOptions[$index] = this.addEmptyItems(this.scopeOptions[$index], false)
					}
					this.$set(this.scopeTable, $index, { ...row, dict_ids: filterE })
					break
				}
			}
		},
		deleteAllScope() {
			if (this.scopeTable.length <= 0) return
			this.$confirm('是否清空应用范围列表', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.scopeTable.splice(0, this.scopeTable.length)
				this.scopeOptions.splice(0, this.scopeOptions.length)
			})
		},
		deleteScope(row, index) {
			if (row.school_stage) {
				this.$confirm('是否删除该题目的关联的应用范围？', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.scopeTable.splice(index, 1)
					this.scopeOptions.splice(index, 1)
				})
			} else {
				this.scopeTable.splice(index, 1)
				this.scopeOptions.splice(index, 1)
			}
		},
		addScope() {
			this.scopeTable.push({
				school_stage: '',
				publisher_id: '',
				textbook_id: '',
				apply_grade: '',
				apply_volume: '',
				dict_ids: []
			})
		},
		// 加载scope应用范围的回显，以及多个接口的数据枚举都要回显
		async scopeLoad(params) {
			const { question_apply_scope } = params
			this.scopeTable = question_apply_scope.map(item => {
				return {
					school_stage: item.school_stage,
					publisher_id: item.publisher_id,
					textbook_id: item.textbook_id,
					apply_grade: item.apply_grade,
					apply_volume: item.apply_volume,
					dict_ids: item.textbook_id == 0 ? [[0]] : item.dict_ids
				}
			})
			this.scopeTable.forEach(async (el, index) => {
				this.getPublisherId(el.school_stage, index, true)
				await this.getTextbooks(
					{
						publisher_id: el.publisher_id,
						school_stage: el.school_stage
					},
					index
				)
				let book = this.textbook[index].find(item => item.id == el.textbook_id)
				this.scopeGrade = [[...this.all_grade, { name: '全部', val: 0 }].find(item => item.val == el.apply_grade)]
				this.scopeVolume = [
					[...this.fb_apply_volume, { label: '全部', value: 0 }].find(item => item.value == el.apply_volume)
				]
				if (book?.directory) {
					const options = this.removeEmptyItems(book?.directory, 'children')
					options.unshift({ id: 0, direct_name: '全部', children: undefined })
					this.scopeOptions[index] = options
				} else {
					this.scopeOptions[index] = [{ id: 0, direct_name: '全部', children: undefined }]
					this.$set(this.scopeTable, index, {
						...el,
						dict_ids: [[0]]
					})
				}
			})
		},
		onInsertText(e) {
			this.ruleForm.answer = e.answer
			this.ruleForm.body = e.body
		},
		handleChange(e) {
		},
		changeItems(event) {
			this.items = event
			this.ruleForm.branches = event
		},
		changeAll(event) {
			this.items = event.items
			this.connections = event.connections
			this.ruleForm.branches = event.items
			this.ruleForm.answer = event.connections
		},
		changeConnections(event) {
			this.connections = event
			this.ruleForm.answer = event
		},
		async initPage() {
			const userInfo = this.$store.state.user.userInfo
			if (userInfo?.teachers?.length >= 1) {
				const teacherInfo = this.$store.state.user.userInfo?.teachers[0]
				this.apply_grade = [
					...(teacherInfo.school.primary_school ? primarySchool : []),
					...(teacherInfo.school.middle_school ? middleSchool : []),
					...(teacherInfo.school.high_school ? highSchool : [])
				]
			} else {
				this.apply_grade = this.all_grade
			}
			// this.typeList = typeList
			this.fb_apply_volume = fb_apply_volume
			this.difficultyList = difficultyList
			const { id, scope_type } = this.$route.query
			this.scope_type = scope_type
			// this.getPublisherId()
			const { question } = await this.$api.question_set.getQuestionDetail(id)
			this.typeList = questionType[question.subject_id]
			this.ruleForm = question
			// 初始化表现分相关字段
			this.$set(this.ruleForm, 'evaluationScoreRows', [])
			this.$set(this.ruleForm, 'is_evaluation_switch', question.is_evaluation_switch || 0)
			this.getKnowPointList()
			this.getPowerPointList()
			await this.scopeLoad(question)
			this.deletObjectKey(['duration_limit', 'publisher', 'question_set_id', 'parent_question_id'], this.ruleForm)
			this.ruleForm.format = 'raw'
			// if (this.ruleForm.media === isNull) {
			// 	this.ruleForm.media = []
			// } else {
			// 	this.echoFile = cloneDeep(this.ruleForm.media)
			// }
			this.subjectTypeChangeEvent(this.ruleForm.type, 'onload')

			/** 配色题 */
			if (question.type === 14) {
				this.matchColor = JSON.parse(question.extras[0])
			}

			/** 拼图题 */
			if (question.type === 13) {
				this.puzzle = JSON.parse(question.extras[0])
			}


			/** 表现分回显 */
			if (question.evaluation_score && question.evaluation_score.length > 0) {
				this.ruleForm.evaluationScoreRows = question.evaluation_score.map(item => ({
					...item,
					_uid: Date.now() + Math.random()
				}))
			}
		},
		deletObjectKey(keysToRemove = [], data) {
			for (const key of keysToRemove) delete data[key]
		},
		async getKnowPointList() {
			const data = await this.$api.question_set.getKnowPointList({
				fb_subject_id: this.ruleForm.subject_id
			})
			this.konwPointTags = data
		},
		async getPowerPointList() {
			const data = await this.$api.question_set.getPowerPointList({
				fb_subject_id: this.ruleForm.subject_id
			})
			this.powerPointTags = data
		},
		async getPublisherId(e, index, isAll = false) {
			const { data } = await this.$api.question_set.getPublisherId({
				// school_stage: e == 0 ? '' : e
				fb_subject_id: this.ruleForm.subject_id
			})
			if (data.length >= 2) {
				this.$set(this.publisherIdTags, index, [{ id: 0, name: '全部' }, ...data])
			} else {
				// isAll备课跳过来的强行添加全部
        if (isAll) this.$set(this.publisherIdTags, index, [{ id: 0, name: '全部' }, ...data])
        else this.$set(this.publisherIdTags, index, data)
			}
		},
		getMousePos(event) {
			var e = event || window.event
			var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft
			var scrollY = document.documentElement.scrollTop || document.body.scrollTop
			var x = e.pageX || e.clientX + scrollX
			var y = e.pageY || e.clientY + scrollY
			//alert('x: ' + x + '\ny: ' + y);
			return { x: x, y: y }
		},
		updateContent(type, { content, delta }) {
			// this.ruleForm.extras = { ...this.ruleForm.extras, [type]: delta }
			this.ruleForm[type] = content
		},
		onInput(index, { content, delta }) {
			// this.ruleForm.extras = { ...this.ruleForm.extras, [type]: delta }
			this.list[index].content = content
		},
		// 上传成功之后的回调,获取到链接
		customUpload({ response, fileUrlData }) {
			fileUrlData.push(response.uri)
		},
		// 删除表单上传的file文件路径
		deleteUpload({ index, fileUrlData }) {
			fileUrlData.splice(index, 1)
		},
		subjectTypeChangeEvent(e, type = 'change') {
			switch (e) {
				case '单选题' | 1:
					if (type === 'onload') {
						this.populateList()
					} else {
						this.list = []
						this.ruleForm.branches = []
						this.ruleForm.extras = []
						this.ruleForm.answer = ''
						this.ruleForm.body = ''
						this.body = ''
					}
					this.radioFormFlag = true
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = false
					this.matchColorVisible = false
					this.puzzleVisible = false
					this.artisticFeaturesVisible = false
					this.musicalFeatureVisible = false
					this.mappingVisible = false
					this.placeholder = '请在此输入题目内容，如：你认为下列哪张图片具有藏族特色？'
					break
				case '多选题' | 2:
					if (type === 'onload') {
						this.populateList()
					} else {
						this.list = []
						this.ruleForm.extras = []
						this.ruleForm.branches = []
						this.ruleForm.answer = []
						this.ruleForm.body = ''
						this.body = ''
					}
					this.radioFormFlag = false
					this.moreRadioFormFlag = true
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = false
					this.matchColorVisible = false
					this.puzzleVisible = false
					this.artisticFeaturesVisible = false
					this.musicalFeatureVisible = false
					this.mappingVisible = false
					this.placeholder = '请在此输入题目内容，如：你认为下列哪张图片具有藏族特色？'
					break
				case '填空题' | 3:
					if (type === 'onload') {
						this.populateBody()
					} else {
						this.ruleForm.extras = []
						this.ruleForm.branches = []
						this.ruleForm.answer = []
						this.ruleForm.body = ''
						this.body = ''
					}
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = true
					this.connectFormFlag = false
					this.singFormFlag = false
					this.matchColorVisible = false
					this.puzzleVisible = false
					this.artisticFeaturesVisible = false
					this.musicalFeatureVisible = false
					this.mappingVisible = false
					this.placeholder = '请在此输入题目内容，如：《命运交响曲》的作者是'
					break
				case '连线题' | 11:
					if (type === 'onload') {
						this.populateItems()
					} else {
						this.ruleForm.branches = {
							left: [],
							right: []
						}
						this.ruleForm.extras = []
						this.ruleForm.answer = []
						this.ruleForm.body = ''
						this.body = ''
					}
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = true
					this.singFormFlag = false
					this.matchColorVisible = false
					this.puzzleVisible = false
					this.artisticFeaturesVisible = false
					this.musicalFeatureVisible = false
					this.mappingVisible = false
					this.placeholder =
						'请将左边的项目与右边有关联的项目连线，一个左边项目可以连接多个右边的项目，右边项目也可能存在悬空项'
					break
				case '节奏题' | 4:
				case '视唱旋律题' | 5:
				case '可视化演唱题' | 9:
				case '演唱题' | 7:
				case '拾音练习题' | 18:
				case '弹奏题' | 24:
					if (type === 'onload') {
						this.populateSing()
					} else {
						this.ruleForm.body = ''
						this.body = ''
						this.ruleForm.musical_id = ''
						this.ruleForm.extras = []
					}
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = true
					this.matchColorVisible = false
					this.puzzleVisible = false
					this.artisticFeaturesVisible = false
					this.musicalFeatureVisible = false
					this.mappingVisible = false
					break
				case '填充题' | 12:
					if (type === 'onload') {
						console.log(this.ruleForm, '90909')
					} else {
						this.ruleForm.body = ''
						this.body = ''
						this.ruleForm.answer = []
					}
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = false
					this.matchColorVisible = false
					this.puzzleVisible = false
					this.mappingVisible = true
					this.artisticFeaturesVisible = false
					this.musicalFeatureVisible = false
					this.ruleForm.create_type = ''
					break

				case 13:
					if (type === 'onload') {
						this.populateSing()
					} else {
						this.ruleForm.body = ''
						this.body = ''
					}
					this.ruleForm.answer = []
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = false
					this.matchColorVisible = false
					this.puzzleVisible = true
					this.artisticFeaturesVisible = false
					this.musicalFeatureVisible = false
					this.ruleForm.create_type = ''
					break

				case 14:
					if (type === 'onload') {
						this.populateSing()
					} else {
						this.ruleForm.body = ''
						this.body = ''
					}
					this.ruleForm.answer = []
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = false
					this.matchColorVisible = true
					this.puzzleVisible = false
					this.artisticFeaturesVisible = false
					this.musicalFeatureVisible = false
					this.mappingVisible = false
					this.ruleForm.create_type = ''
					break
				case 16:
					this.ruleForm.body = ''
					this.ruleForm.answer = []
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = false
					this.matchColorVisible = false
					this.puzzleVisible = false
					this.artisticFeaturesVisible = true
					this.musicalFeatureVisible = false
					this.ruleForm.create_type = ''
					this.mappingVisible = false
					break

				case 17:
					this.ruleForm.body = ''
					this.ruleForm.answer = []
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = false
					this.matchColorVisible = false
					this.puzzleVisible = false
					this.artisticFeaturesVisible = false
					this.musicalFeatureVisible = true
					this.mappingVisible = false
					this.ruleForm.create_type = ''
					break

				case 10:
					if (type === 'onload') {
						this.populateList()
					} else {
						this.list = []
						this.ruleForm.branches = []
						this.ruleForm.answer = []
						this.ruleForm.body = ''
						this.body = ''
					}
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = false
					this.matchColorVisible = false
					this.puzzleVisible = false
					this.artisticFeaturesVisible = false
					this.musicalFeatureVisible = false
					this.mappingVisible = false
					break
			}
		},
		populateList() {
			this.list = this.ruleForm.branches?.map(item => {
				this.index++
				return {
					id: new Date().getTime() + this.index,
					content: item,
					focused: false
				}
			})
		},
		populateItems() {
			this.items = this.ruleForm.branches
			this.connections = this.ruleForm.answer
		},
		populateSing() {
			let body = this.ruleForm.body
			this.body = body
			if (this.ruleForm.type == 18) {
				this.textValue = this.ruleForm.extras[2]?.map(item => item.cm)
			}
		},
		populateBody() {
			let body = this.ruleForm.body
			this.ruleForm.answer.forEach(item => {
				body = body.replace('[@~]', item)
			})
			this.body = body
		},
		submitForm(formName) {
			this.errorTipVisibe = false
			if (this.submitFormLoading) return

			this.submitFormLoading = true
			if (!this.connectFormFlag && !this.mappingVisible) {
				// 因为onInput已经更新了连线的状态，其实都可以放在这里一起更新的，因为有连线的样式，所以只能提前更新
				this.ruleForm.branches = this.list.map(item => {
					return item.content
				})
			}
			let params = {
				...this.ruleForm,
				scope: this.scopeTable.map(item => {
					return {
						...item,
						// dict_id: item.dict_ids[item.dict_ids.length - 1]
						dict_id: item.dict_ids.map(element => element[element.length - 1])
					}
				}),
				body: this.ruleForm.body.replace(/((<p><br>\s*<\/p>)+)/g, '<p><br></p>')
			}
			if (this.ruleForm.type == 18 && !params.extras[1]) {
				// this.$message.error('未识别谱例')
				this.submitFormLoading = false
				this.errorTipVisibe = true
				return
			}
			this.$refs[formName].validate(async valid => {
				if (valid) {
					// 表现分开关开启时才传递 question_value
					params.evaluation_score = this.getValidEvaluationScore() || []
					// // 配色题就赋值matchColor到extras
					// if (this.ruleForm.type === 12) {
					// 	params.extras = []
					// 	params.extras[0] = JSON.stringify(this.matchColor)
					// }

					// 拼图题就赋值matchColor到extras
					if (this.ruleForm.type === 13) {
						params.extras = []
						params.extras[0] = JSON.stringify(this.puzzle)
					}

					if (this.ruleForm.type === 14) {
						params.extras = []
						params.extras[0] = JSON.stringify(this.matchColor)
					}
					try {
						const { id } = await this.$api.question_set.editQuestions(this.ruleForm.id, params)
						this.routeBack(id)
					} catch (err) {
						this.submitFormLoading = false
					}
				} else {
					await this.$nextTick()
					const el = document.querySelectorAll('.el-form-item__error')[0];
					el.scrollIntoView({ block: 'center', behavior: 'smooth' });
					this.submitFormLoading = false
					return false
				}
			})
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
		},
		routeBack(id = '') {
			console.log(id, '-----')
			const { isJump } = this.$route.query
			if (isJump) {
				this.$router.push(`/workbench/abilityList/${this.ruleForm.subject_id}`)
			} else {
				if (this.previewEdit.seeVisible) {
					// 神奇的bug，只要识别过谱例，就无法跳转
					this.$router.push(`/workbench/abilityList/${this.ruleForm.subject_id}`)
				}
				if (id != '') {
					this.$router.push(`/workbench/abilityList/${this.ruleForm.subject_id}/look?id=${id}&isJump=new`)
				} else {
					this.$router.go(-1)
				}
			}
		},
		// 添加题肢数据
		inscriptionNewCreateClick() {
			if (this.ruleForm.type == 10) {
				if (this.list.length >= 15) return this.$message.error('最多添加14个题')
			}
			this.list.push({
				id: new Date().getTime(),
				content: '',
				focused: false,
				file: ''
			})
		},
		// 删除题肢数据
		inscriptionDeleteClick(id, sort) {
			const index = this.list.findIndex(item => {
				return item.id === id
			})
			this.list.splice(index, 1)
			// 单选
			if (this.radioFormFlag) {
				if (index == this.ruleForm.answer) {
					this.ruleForm.answer = ''
				} else if (index < this.ruleForm.answer) {
					this.ruleForm.answer = this.ruleForm.answer - 1
				}
			}
			// 多选
			if (this.moreRadioFormFlag) {
				this.ruleForm.answer.forEach((item, idx) => {
					if (index == item) {
						this.ruleForm.answer.splice(idx, 1)
					} else if (index < item) {
						this.ruleForm.answer.splice(idx)
						return
					}
				})
			}
		},
		// 数字转换字母
		numToColNo(num) {
			if (num < 0 || num > 26) {
				return ''
			}
			const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
			return letters.charAt(num)
		},
		changeColorFillQuestion(data) {
			console.log(data, 'data')
			this.ruleForm = data
		},
		// 表现分相关方法
		handleAddEvaluationRow() {
			this.ruleForm.evaluationScoreRows.push({
				_uid: Date.now(),
				percentage: '',
				score: '',
				percentageError: false,
				scoreError: false
			})
		},
		handleDeleteEvaluationRow(index) {
			this.ruleForm.evaluationScoreRows.splice(index, 1)
			this.checkDuplicatePercentage()
		},
		handlePercentageInput(index) {
			let value = this.ruleForm.evaluationScoreRows[index].percentage
			if (value === '' || value === null || value === undefined) {
				return
			}
			value = String(value)
			const cleaned = value.replace(/[^\d]/g, '')
			if (cleaned !== value) {
				value = cleaned
			}
			if (value !== '') {
				const num = parseInt(value, 10)
				if (!isNaN(num)) {
					if (num < 0) value = '0'
					if (num > 100) value = '100'
				}
			}
			this.$set(this.ruleForm.evaluationScoreRows, index, {
				...this.ruleForm.evaluationScoreRows[index],
				percentage: value,
				percentageError: false
			})
		},
		handlePercentageBlur(index) {
			const value = this.ruleForm.evaluationScoreRows[index].percentage
			if (value !== '' && value !== null && value !== undefined) {
				const num = Number(value)
				this.$set(this.ruleForm.evaluationScoreRows, index, {
					...this.ruleForm.evaluationScoreRows[index],
					percentage: Math.min(100, Math.max(0, num))
				})
			}
			this.checkDuplicatePercentage()
			this.sortByPercentage()
		},
		handleScoreInput(index) {
			let value = this.ruleForm.evaluationScoreRows[index].score
			if (value === '' || value === null || value === undefined) {
				return
			}
			value = String(value)
			// 智能输入：处理前导0的情况
      // 如果是 "0" 开头且有多个0，或者"0"后面跟的不是小数点，则只保留一个0
      if (value.length > 1 && value[0] === '0' && value[1] !== '.') {
        // 去掉所有前导0，保留一个
        value = '0' + value.substring(1).replace(/^0+/, '')
      }
      // 处理负数的情况："-0" 开头且后面跟的不是小数点
      if (value.length > 2 && value[0] === '-' && value[1] === '0' && value[2] !== '.') {
        // 去掉多余的0，只保留一个0
        value = '-0' + value.substring(2).replace(/^0+/, '')
      }
			const cleaned = value.replace(/[^\d.-]/g, '')
			if (cleaned !== value) {
				value = cleaned
			}
			if (value.indexOf('-') > 0) {
				value = value.replace(/-/g, '')
			}
			const negativeCount = (value.match(/-/g) || []).length
			if (negativeCount > 1) {
				value = '-' + value.replace(/-/g, '')
			}
			if (value === '.') {
				value = '0.'
			}
			if (value === '-.') {
				value = '-0.'
			}
			const dotCount = (value.match(/\./g) || []).length
			if (dotCount > 1) {
				const firstDotIndex = value.indexOf('.')
				value = value.substring(0, firstDotIndex + 1) + value.substring(firstDotIndex + 1).replace(/\./g, '')
			}
			const dotIndex = value.indexOf('.')
			if (dotIndex !== -1 && value.length > dotIndex + 2) {
				value = value.substring(0, dotIndex + 2)
			}
			if (value && value !== '-' && value !== '.' && value !== '-.') {
				const num = parseFloat(value)
				if (!isNaN(num)) {
					if (num < -99.9) value = '-99.9'
					if (num > 99.9) value = '99.9'
				}
			}
			this.$set(this.ruleForm.evaluationScoreRows, index, {
				...this.ruleForm.evaluationScoreRows[index],
				score: value,
				scoreError: false
			})
		},
		handleScoreBlur(index) {
			let value = this.ruleForm.evaluationScoreRows[index].score
			if (value === '' || value === null || value === undefined) {
				this.$set(this.ruleForm.evaluationScoreRows, index, {
					...this.ruleForm.evaluationScoreRows[index],
					scoreError: true,
					score: ''
				})
				return
			}
			const num = parseFloat(value)
			if (!isNaN(num)) {
				let finalValue = num
				if (num < -99.99) finalValue = -99.99
				if (num > 99.99) finalValue = 99.99
				this.$set(this.ruleForm.evaluationScoreRows, index, {
					...this.ruleForm.evaluationScoreRows[index],
					score: finalValue,
					scoreError: false
				})
			}
		},
		checkDuplicatePercentage() {
			this.ruleForm.evaluationScoreRows.forEach(row => {
				row.percentageError = false
			})
			const percentageMap = {}
			this.ruleForm.evaluationScoreRows.forEach((row, index) => {
				const p = row.percentage
				if (p !== '' && p !== null && p !== undefined) {
					if (percentageMap[p] !== undefined) {
						this.ruleForm.evaluationScoreRows[percentageMap[p]].percentageError = true
						this.ruleForm.evaluationScoreRows[index].percentageError = true
					} else {
						percentageMap[p] = index
					}
				}
			})
		},
		sortByPercentage() {
			this.ruleForm.evaluationScoreRows.sort((a, b) => {
				const pA = a.percentage
				const pB = b.percentage
				if (pA === '' || pA === null || pA === undefined) return 1
				if (pB === '' || pB === null || pB === undefined) return -1
				return pA - pB
			})
		},
		getValidEvaluationScore() {
			// 检查每一行的百分比和分值
			let hasEmptyError = false
			this.ruleForm.evaluationScoreRows.forEach((row, index) => {
				const percentageEmpty = row.percentage === '' || row.percentage === null || row.percentage === undefined
				const scoreEmpty = row.score === '' || row.score === null || row.score === undefined
				if ((!percentageEmpty && scoreEmpty) || (percentageEmpty && !scoreEmpty)) {
					if (percentageEmpty) {
						this.$set(this.ruleForm.evaluationScoreRows, index, { ...row, percentageError: true })
					}
					if (scoreEmpty) {
						this.$set(this.ruleForm.evaluationScoreRows, index, { ...this.ruleForm.evaluationScoreRows[index], scoreError: true })
					}
					hasEmptyError = true
				}
			})
			const hasError = this.ruleForm.evaluationScoreRows.some(row => row.percentageError || row.scoreError)
			if (hasError || hasEmptyError) {
				return null
			}
			// 过滤空行
			return this.ruleForm.evaluationScoreRows
				.filter(row =>
					row.percentage !== '' && row.percentage !== null && row.percentage !== undefined &&
					row.score !== '' && row.score !== null && row.score !== undefined
				)
				.map(row => ({
					percentage: row.percentage,
					score: row.score
				}))
		}
	},
	mounted() {
	},
	created() { 
		this.initPage()
	}
}
</script>
<style lang="scss" scoped>
.num-input {
	/deep/ .el-input-number__decrease {
		display: none;
	}

	/deep/ .el-input-number__increase {
		display: none;
	}
}

.scope-table {
	/deep/ .el-table__empty-block {
		min-height: 0px !important;
	}

	/deep/ .el-cascader__tags {
		display: inline-flex;
		margin-right: 40px;
		flex-wrap: nowrap;
	}

	/deep/ .cell {
		height: 45px !important;
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
}

.scope-button {
	// min-width: 764px;
	max-width: 1028px;
	border: 1px solid #ebeef5;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	height: 50px;
	padding-right: 10px;
	// /deep/ .el-button {
	// 	background: #f7f8fa;
	// }
}

.flex {
	display: flex;
}

.flex-align-center {
	display: flex;
	align-items: center;
}

.flex-align-baseline {
	display: flex;
	align-items: baseline;
}

.flex-center-center {
	display: flex;
	align-items: center;
	justify-content: center;
}

.ability-detail {
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	padding-bottom: 40px;
	overflow: hidden;

	.ability-detail-header {
		display: flex;
		align-items: center;
		padding: 15px 15px 15px 25px;
		margin-bottom: 20px;
		font-size: 16px;
		cursor: pointer;
	}

	.ability-detail-header:hover {
		color: #ff5e2a;
	}

	.connect-line {
		/deep/ .edit-mode-item {
			height: 180px;
		}

		/deep/ .ql-editor {
			width: 270px;
			height: 140px;
		}
	}
}

.ability-detail-form {
	padding: 0px 124px;

	.form-item-title {
		font-size: 16px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #525252;
		margin-bottom: 18px;
	}

	// .form-item-upload-i{
	//   /deep/ .el-upload-list{
	//     display: none !important;
	//   }
	// }
}

.form-item-inscription {
	border-radius: 3px 3px 3px 3px;
	border: 1px solid #dcdcdc;
	padding: 8px 20px 20px 20px;
	max-width: 900px;
	box-sizing: border-box;

	.form-item-inscription-tip {
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #908f8f;
	}

	.form-item-inscription-button {
		width: 104px;
		height: 32px;
		border-radius: 4px 4px 4px 4px;
		opacity: 1;
		border: 1px solid #dddddd;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: auto;
	}

	/deep/ .el-checkbox {
		margin-right: 8px;
	}

	/deep/ .el-checkbox-group {
		font-size: 14px;
	}
}

.icon-circle {
	width: 30px;
	height: 30px;
	background: #fff1f1;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

.width-614 {
	width: 614px;
}

.width-453 {
	width: 453px;
}

.width-900 {
	width: 900px;
}

.video {
	position: fixed;
	top: 0;
	left: 0;
}

.quill-text {
	flex: 1;
	margin-right: 10px;
	max-width: 720px;
}

// 表现分表格样式
.evaluation-score-table {
	width: 500px;
	border: 1px solid #EBEEF5;
	border-radius: 4px;

	.table-header {
		display: flex;
	}

	.table-body {
		max-height: 300px;
		overflow-y: auto;
	}

	.table-row {
		display: flex;
		border-top: 1px solid #EBEEF5;

		&:last-child {
			border-bottom: none;
		}
	}

	.table-cell {
		flex: 1;
		height: 54px;
		padding: 0 10px;
		text-align: center;
		border-right: 1px solid #EBEEF5;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #908F8F;
		font-size: 14px;

		&:last-child {
			border-right: none;
		}

		.el-input {
			width: 100%;
		}

		/deep/ .el-input__inner {
			text-align: center;
		}
	}

	.is-error {
		/deep/ .el-input__inner {
			border-color: #F56C6C;
		}
	}

	.table-cell-action {
		flex: 0 0 80px;
	}

	.delete-btn {
		color: #4B4B4B;
		cursor: pointer;
		font-size: 14px;
    display: flex;
		&:hover {
			color: #FF5E2A;
		}
	}

	.table-footer {
		position: relative;
		padding: 0 12px;
		height: 54px;
		border-top: 1px solid #EBEEF5;
		align-items: center;
	}

	.add-btn {
		position: relative;
		color: #FF5E2A;
		cursor: pointer;
		font-size: 14px;
		align-items: center;
		display: flex;
		height: fit-content;

		i {
			margin-right: 4px;
		}

		&:hover {
			color: #ff7b4d;
		}
	}
}

</style>

<style>
.value-tip {
	box-shadow: none !important;
	background-color: transparent !important;
	padding: 0 !important;
	border: none !important;
}
</style>
